module.exports = __webpack_public_path__ + "images/kredito24-55f7b79f.png";